import React from 'react'
// import material ui
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
// import i18n
import { useTranslation } from 'react-i18next';
// import components
import LinkTo from '../../../_components/LinkTo';

const useStyles = makeStyles(theme => ({
    item: {
        paddingTop: 32,
        paddingBottom: 32,
        overflow: "hidden",
        [theme.breakpoints.down(476)]: {
            paddingTop: 16,
            paddingBottom: 16,
        },
    },
    title_link: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
    },
    table: {
        marginTop: 24,
        width: "100%",
        overflowX: "auto",
        "&::-webkit-scrollbar": {
            width: 3,
            height: 3,
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ccc",
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#8E95A9",
            borderRadius: 10,
        },
        [theme.breakpoints.down(960)]: {
            maxHeight: "unset",
        },
    },
}));

const Row = (props) => {
    const { data } = props;
    const {
        order__id,
        price_sell,
        sum_sell,
        quantity,
        currency_sell__simbol,
        name,
    } = data;

    return (
        <TableBody>
            <TableRow>
                <TableCell>#{order__id}</TableCell>
                <TableCell>{name}</TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>{currency_sell__simbol} {price_sell}</TableCell>
                <TableCell>{quantity}</TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>{currency_sell__simbol} {sum_sell}</TableCell>
            </TableRow>
        </TableBody>
    )
}

const TableMoreOrder = (props) => {
    const { data, notAllManagerDataCondition } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={`dashboard-card ${classes.item}`}>
            {notAllManagerDataCondition === true ? <div className="dashboard-card-empty">{t('common:fill_user_details_label')}</div> : data?.length === 0 ? (
                <div className="dashboard-card-empty">{t('common:no_frequent_orders')}</div>
            ) : null}
            <div className={classes.title_link}>
                <h2 className="dashboard-title">{t('common:you_order_the_most')}</h2>
                {/* <LinkTo title={t('common:read_mode_label')} adaptive={true} path={"/dashboard/partner-stock"} /> */}
            </div>
            <div className={classes.table}>
                <Table className="dashboard-table" aria-label="full width table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('common:orders')}</TableCell>
                            <TableCell>{t('common:title_label')}</TableCell>
                            <TableCell>{t('common:price')}</TableCell>
                            <TableCell>{t('common:purchased')}</TableCell>
                            <TableCell>{t('common:sum')}</TableCell>
                        </TableRow>
                    </TableHead>
                    {data?.length > 0 ? data?.slice(0, 3).map((item, index) => <Row key={`more-orders-${index}`} data={item} />) : [0, 1, 2].map((item) => <Row key={`more-orders-${item}`} data={{
                        order__id: 1010101,
                        price_sell: 1010,
                        sum_sell: 1010,
                        quantity: 1,
                        currency_sell__simbol: "$",
                        name: "Daniparts",
                    }} />)}
                </Table>
            </div>
        </div>
    )
}

export default TableMoreOrder